import { Rocket } from "lucide-react";
import { LaunchCountdown } from "@/components/shared/LaunchCountdown";

export const LaunchBanner = () => (
  <section id="launch-banner" data-testid="launch-banner-section" className="bg-rr-navy py-10 relative overflow-hidden">
    <div className="grain-overlay opacity-40" />
    <div className="max-w-3xl mx-auto px-5 md:px-8 text-center relative">
      <div className="inline-flex items-center gap-2 text-rr-orangeLight text-xs font-bold tracking-[0.2em] uppercase mb-4">
        <Rocket size={14} /> Launching January 1, 2027
      </div>
      <LaunchCountdown />
    </div>
  </section>
);
